import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Label } from "./Inputs";

const getState = (model, required) => {
  const error = {};
  if (required) {
    error.footPrint = null;
  }
  return {
    footPrint: model.footPrint || null,
    error,
  };
};

function FootprintForm({
  forwardedRef,
  className = "",
  label = "Footprint",
  model = {
    footPrint: "",
  },
  namePrefix = "",
  footPrints = ["VFW", "VFD", "VFW & VFD"],
  required,
  disabled,
}) {
  const [state, setState] = React.useState(getState(model, required));

  React.useEffect(() => {
    setState(getState(model, required));
  }, [model, required]);

  const validate = React.useCallback(
    (noValidate) => {
      const { error, ...newModel } = state;
      let isValid = true;
      if (
        error.footPrint !== undefined &&
        (newModel.footPrint === null || newModel.footPrint === "")
      ) {
        error.footPrint = true;
        isValid = false;
      }
      if (!noValidate) {
        setState((prev) => ({ ...prev, error }));
      }
      if (!noValidate && !isValid) {
        return null;
      }
      return { ...newModel };
    },
    [state],
  );

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const onChange = React.useCallback((footPrint) => {
    setState((prev) => ({
      ...prev,
      footPrint,
      error: {
        ...prev.error,
        footPrint: null,
      },
    }));
  }, []);

  const options = footPrints.map((value) => ({
    label: value,
    value: value,
  }));
  const formClassName = required
    ? `${state.error.footPrint ? "w3-border-red" : ""}`
    : "";
  return (
    <div className={`${className}`}>
      <Label htmlFor={`${namePrefix}footPrint`} noMargin>
        {label}
      </Label>
      <Dropdown
        id={`${namePrefix}footPrint`}
        className={`w3-block w3-border ${formClassName}`}
        value={state.footPrint}
        placeholder="Footprint auswählen"
        options={options}
        onChange={(event) => onChange(event.value)}
        readOnly={disabled}
        // appendTo={document.getElementById(`${namePrefix}footPrint`)}
        showClear
      />
    </div>
  );
}

FootprintForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    footPrint: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  footPrints: PropTypes.arrayOf(PropTypes.string),
  footPrintOptions: PropTypes.arrayOf(PropTypes.shape({})),
  namePrefix: PropTypes.string,
  required: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <FootprintForm {...props} forwardedRef={ref} />
));
